import React from "react";
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Modal, notification, message } from "@fle-ui/next";
import moment from "moment";
import CommonStore from "../stores/common";
import api from "config/api";
import { mainHost1 } from 'config/index'
import axios from 'axios'

export const isObject = (obj) => {
  return obj !== null && (typeof obj === 'object');
}

const { common } = api;
/**
 * 格式化url参数
 */
export const parseQueryString = () => {
  const url = window.location.href;
  const regUrl = /^[^\?]+\?([\w\W]+)$/; //eslint-disable-line
  const regPara = /([^&=]+)=([\w\W]*?)(&|$|#)/g;
  const arrUrl = regUrl.exec(url);
  let ret = {};
  if (arrUrl && arrUrl[1]) {
    const strPara = arrUrl[1];
    let result;
    while ((result = regPara.exec(strPara)) != null) {
      ret[result[1]] = result[2];
    }
  }
  return ret;
};

/**
 * 时间戳转换
 */
export const repeat = (str = "0", times) => new Array(times + 1).join(str);
// 时间前面 + 0
export const pad = (num, maxLength = 2) =>
  repeat("0", maxLength - num.toString().length) + num;
// 时间格式的转换  12:00:00
export const formatTime = (time) =>
  `${ pad(time.getHours()) }:${ pad(time.getMinutes()) }:${ pad(
    time.getSeconds()
  ) }.${ pad(time.getMilliseconds(), 3) }`;
//  2018-12-12 12:00:00
export const formatAllTime = (time) =>
  `${ time.getFullYear() }-${ pad(time.getMonth() + 1) }-${ pad(
    time.getDate()
  ) } ${ pad(time.getHours()) }:${ pad(time.getMinutes()) }:${ pad(
    time.getSeconds()
  ) }`;
// 自定义转换
export const newFormatTime = (time, fmt = "YYYY-MM-DD HH:mm:ss") => {
  return time ? moment(time).format(fmt) : "";
};

// antd需要的table data-key
export const formatTableKey = (list) => {
  return list.map((val, key) => {
    val.key = key;
    return val;
  });
};

// 商品管理-分类
// 格式化分类table，添加key值
export const formatCateTable = (list, parent) => {
  return list.map((val, key) => {
    val.categoryId = val.categoryId || val.id;
    val.key = `${ Date.now() }${ val.categoryId }`;
    val.index = parent ? parent.index.concat([key]) : [key];
    if (Reflect.has(val, "children")) {
      val.children &&
      val.children.map((value, index) => {
        return (value.key = `${ value.categoryId }-${ index }`);
      });
    }
    return val;
  });
};

// 格式化新增分类-分类treeselect，添加key值，替换属性名; 只显示到1级分类。
export const formatTopCateTree = (list) => {
  const keyArr = list.map((val1, key) => {
    val1.children = []; // 只显示到二级分类
    formatCateTreeItem(val1);
    return val1;
  });
  return keyArr;
};


// 格式化商品库-分类treeselect-无限级，添加key值，替换属性名;
export const formatStoreCateTree = (list, allSelectable) => {
  return list?.map((val1) => {
    checkCateTreeChild(val1, allSelectable);
    formatCateTreeItem(val1, allSelectable);
    return val1;
  });
};
export const checkCateTreeChild = (val, allSelectable) => {
  if (Reflect.has(val, "children")) {
    val.children &&
    val.children.map((item) => {
      checkCateTreeChild(item, allSelectable);
      formatCateTreeItem(item, allSelectable);
      return item;
    });
  }
};

// 分类管理-treeselect，根据后端接口修改字段名
export const formatCateTreeItem = (item, allSelectable = false) => {
  item.key = item.categoryTree;
  item.title = item.categoryName;
  item.id = item.categoryId;
  item.value = item.categoryTree;
  item.pId = item.parentId;
  !allSelectable && (item.selectable = item.categoryLevel !== 1); // 聚货分类需要只选二级，卡券需要一二级
  return item;
};

// 格式化 选择区域select
export const formatArea = (list, pid) => {
  return (
    list &&
    list.map((val) => {
      val.isLeaf = false;
      // val.key = val.code
      // val.pid = pid
      return val;
    })
  );
};

// 匹配地址list对应的id, 返回对应的索引
export const matchAreaId = (list, id) => {
  let index = 0;
  list &&
  list.forEach((item, i) => {
    if (item.code === id) {
      index = i;
    }
  });
  return index;
};

// 商品管理=商品库
// 格式化表单的address入参
export const formatAddress = (val, regions = []) => {
  regions.provinceId = val[0];
  regions.cityId = val[1];
  regions.districtId = val[2];
  return regions;
};

// 去除数组中的empty类型 （建议typeof(key) !== undefined）?'empty'
export const formatEmpty = (arr) => {
  return arr.filter((key) => typeof key !== "empty");
  // return arr.filter(key => typeof(key) !== 'undefined' )
};

// 格式化商城-京东-调价阶梯-入参
export const formatStairPriceParams = (
  _maxNum,
  _minNum,
  _price,
  _rate,
  newArr = []
) => {
  formatEmpty(_maxNum).forEach((item, index) => {
    newArr.push({});
    newArr[index]["maxNum"] = item;
  });
  formatEmpty(_minNum).forEach((item, index) => {
    newArr[index]["minNum"] = item;
  });
  _price &&
    formatEmpty(_price).forEach((item, index) => {
      newArr[index]["price"] = item * 100;
    });
  _rate &&
    formatEmpty(_rate).forEach((item, index) => {
      newArr[index]["priceRate"] = item;
    });
  return newArr;
};

// 搜索时-价格单位-元转化成分
export const formatPriceUnitEnlarge = (values) => {
  if (values.supplyPriceMin)
    values.supplyPriceMin = values.supplyPriceMin * 100;
  if (values.supplyPriceMax)
    values.supplyPriceMax = values.supplyPriceMax * 100;
  if (values.priceMax) values.priceMax = values.priceMax * 100;
  if (values.priceMin) values.priceMin = values.priceMin * 100;
  return values;
};
// 分转元
export const regFenToYuan = (fen) => {
  let num = fen;
  num = fen * 0.01;
  num += "";
  let reg =
    num.indexOf(".") > -1
      ? /(\d{1,3})(?=(?:\d{3})+\.)/g
      : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num = num.replace(reg, "$1");
  num = toDecimal2(num);
  return num;
};

export const formatPrice = regFenToYuan

export const toDecimal2 = (x) => {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + 2) {
    s += "0";
  }
  return s;
};

export const formatHomeOperateCateTree = (list) => {
  const keyArr = list.map((val1, key) => {
    if (Reflect.has(val1, "children")) {
      val1.children &&
      val1.children.map((val2, index) => {
        val2.children = []; // 只显示到二级分类
        formatHomeOperateCateTreeItem(val2);
        return val2;
      });
    }
    formatHomeOperateCateTreeItem(val1);
    return val1;
  });
  return keyArr;
};

export const formatHomeOperateCateTreeItem = (item) => {
  item.key = item.categoryTree;
  item.title = item.categoryName;
  item.id = item.categoryId;
  item.value = item.categoryTree;
  item.pId = item.parentId;
  return item;
};

//路由参数
export const getQueryVariableToObj = () => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  const _obj = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    _obj[pair[0]] = pair[1];
  }
  return _obj;
};

/**
 * JSON 克隆
 * @param {Object | Json} jsonObj json对象
 * @return {Object | Json} 新的json对象
 */
export function objClone(jsonObj) {
  var buf;
  if (jsonObj instanceof Array) {
    buf = [];
    var i = jsonObj.length;
    while (i--) {
      buf[i] = objClone(jsonObj[i]);
    }
    return buf;
  } else if (jsonObj instanceof Object) {
    buf = {};
    for (var k in jsonObj) {
      buf[k] = objClone(jsonObj[k]);
    }
    return buf;
  } else {
    return jsonObj;
  }
}
/**
 * 下载接口返回的文件流
 * @param {*} data 文件流
 * @param {*} type 文件类型
 * @param {*} fileName 下载文件名
 */
export function downloadFile(data, type = "vnd.ms-excel", fileName = "") {
  const blob = new Blob([data], { type: `application/${type};charset=utf-8` });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download =
    fileName || newFormatTime(new Date(), "YYYYMMDDHHmmss") + "下载文件";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

/**
 * 图片弹窗预览
 * @param {*} file 文件对象
 * @param {*} width 弹窗宽度
 */
export const previewImg = (file, width = 420) => {
  Modal.info({
    content: <img style={ { width: "100%" } } src={ file.thumbUrl || file.url } alt={ '' }/>,
    width,
    icon: <LegacyIcon type={ null }/>,
    maskClosable: true,
    okButtonProps: {
      style: { display: "none" },
    },
    cancelButtonProps: {
      style: { display: "none" },
    },
  });
};

/**
 * 上传文件
 * @param {*} file 文件信息
 * @param {*} path 上传到oss后存放的地址
 */
export const getImgUrl = async (file, path = "resource/elebuys") => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("directory", path);
  return await CommonStore.uploadSingleFileNew(formData);
};
export const toGoodsDetail = (goodsId = "") => {
  if (!goodsId) return;

  window.open(`/goods/detail?id=${goodsId}`);
};
export const toChinesNum = (num) => {
  let changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  let unit = ["", "十", "百", "千", "万"];
  num = parseInt(num);
  let getWan = (temp) => {
    let strArr = temp.toString().split("").reverse();
    let newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == 0
          ? ""
          : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
          ? ""
          : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
        newNum;
    }
    return newNum;
  };
  let overWan = Math.floor(num / 10000);
  let noWan = num % 10000;
  if (noWan.toString().length < 4) {
    noWan = "0" + noWan;
  }
  return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
};

export const replaceParams = (url, arg, arg_val) => {
  const pattern = arg + "=([^&]*)";
  const replaceText = arg + "=" + arg_val;
  if (url.match(pattern)) {
    let tmp = "/(" + arg + "=)([^&]*)/gi";
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match("[?]")) {
      return url + "&" + replaceText;
    } else {
      return url + "?" + replaceText;
    }
  }
};

// 防抖
export const debounce = (fn, wait) => {
  var timeout = null;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments);
    }, wait);
  };
};

export const formatMyTime = (time, fmt = "YYYY-MM-DD HH:mm:ss") => {
  return time ? moment(time).format(fmt) : "";
};

//复制地址
export const copyStr = (str) => {
  const dom = document.createElement("input");
  dom.value = str;
  document.body.appendChild(dom);
  dom.select(); // 选中文本
  document.execCommand("copy"); // 执行浏览器复制命令
  document.body.removeChild(dom);
};

export function ExportFile(
  url = "",
  data = {},
  name = "",
  blobType = 'application/x-zip-compressed',
  fileEnd = '.zip',
  handel = () => {},
  handel2 = () => {}
) {
  axios({
    method: "GET",
    baseURL: mainHost1,
    headers: {
      // @ts-ignore
      authority_token: localStorage.getItem("token"),
    },
    url,
    params: data,
    responseType: "blob",
  })
    .then((data) => {
      const blob = new Blob([data.data], {
        type: blobType,
      });
      const fileReader = new FileReader();
      fileReader.readAsText(blob);
      fileReader.onload = function () {
        try {
          const result = JSON.parse(this.result);
          if (result && result.success === false) {
            notification.error({
              message: "提示",
              description: result.message,
            });
            handel2();
          } else {
            // reject();
            handel2();
          }
        } catch (e) {
          //TODO handle the exception
          // reject();
          if (data.status === 200) {
            // 截取文件名，这里是后端返回了文件名+后缀，如果没有可以自己拼接
            let fileName = `${name ? name : newFormatTime(new Date())}${fileEnd}`;
            // 将`blob`对象转化成一个可访问的`url`
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            handel();
          }
        }
      };
    })
    .catch(() => {
      message.error("导出失败");
    });
}


// 导出文件
export function ExportFileNew(obj) {
  const {
    method = 'post',
    url = '',
    data = {},
    fileName = `${showTime(new Date(), "YYYYMMDDHHmmss")}`,
    blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    successFn = () => { },
    failFn = () => { },
  } = obj

  const axiosConfig = {
    method,
    baseURL: mainHost1,
    headers: {
      // @ts-ignore
      authority_token: localStorage.getItem("token"),
    },
    url,
    data,
    responseType: "blob",
  }
  if (method === 'get') {
    axiosConfig.params = data
    delete axiosConfig.data
  }
  // @ts-ignore
  axios(axiosConfig)
    .then((data) => {
      const blob = new Blob([data.data], {
        type: blobType,
      });
      const fileReader = new FileReader();
      fileReader.readAsText(blob);
      fileReader.onload = function () {
        try {
          // @ts-ignore
          const result = JSON.parse(this.result);
          if (result && result.success === false) {
            Notification.error({
              message: "提示",
              description: result.message,
            });
            failFn();
          } else {
            // reject();
            failFn();
          }
        } catch (e) {
          // reject();
          if (data.status === 200) {
            // 将`blob`对象转化成一个可访问的`url`
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            successFn();
          }
        }
      };
    })
    .catch(() => {
      message.error("导出失败");
      failFn()
    });
}

// 延时工具
export const waitTime = (time) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve('');
    }, time)
  })
}


export const showTime = (data, fmtType = 'YYYY-MM-DD HH:mm:ss') =>
    data ? moment(data).format(fmtType) : '';
